
export class DailyReport {
    static fromExistingData(report: any) {
        const dailyReport = new DailyReport();

        if (report.building) dailyReport.buildingId = +report.building.bdId;
        if (report.building) dailyReport.buildingName = report.building.name;
        if (report.id) dailyReport.id = +report.id;
        if (report.dailyReportNumber) dailyReport.dailyReportNumber = report.dailyReportNumber;
        if (report.createdBy) dailyReport.reportedBy = report.createdBy.fullName;
        if (report.endDate) dailyReport.endDate = report.endDate;
        if (report.startDate) dailyReport.startDate = report.startDate;
        if (report.relieved) dailyReport.relieved = report.relieved;
        if (report.relievedBy) dailyReport.relievedBy = report.relievedBy;
        if (report.status) dailyReport.status = report.status;
        if (report.entries) dailyReport.entries = report.entries;
        if (report.createdAt) dailyReport.createdAt = report.createdAt;
        dailyReport.isCanEdit = report.isCanEdit;
        dailyReport.isCanDelete = report.isCanDelete;
        return dailyReport;
    }

    constructor(
        public id: number = null,
        public checked: boolean = false,
        public buildingId: number = null,
        public buildingName: string = '',
        public dailyReportNumber: string = '',
        public reportedBy: string = '',
        public status: string = '',
        public endDate: string = '',
        public startDate: string = '',
        public relieved: string = '',
        public relievedBy: string = '',
        public createdAt: string = '',
        public entries: Array<any> = [],
        public details: any = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            building: {editMode: false},
            relieved: {editMode: false},
            relievedBy: {editMode: false},
            startDate: {editMode: false},
            endDate: {editMode: false}
        },
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/DailyReport.ts